import { dataCrown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCrown = /*#__PURE__*/createIcon(dataCrown)
export default IconCrown
